import cl from 'classnames'
import styles from './styles.module.scss'

type Props = {
  className?: string
}

export const AboutCompany = ({ className }: Props) => {
  return (
    <div className={cl(className)}>
      <h2 className="text-center font-chivo text-3xl font-black">
        Conheça o Portal Solar
      </h2>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-5 mt-6">
        <div className={styles.wrapperContainer}>
          <div className={styles.backgroundImage}></div>
        </div>
        <div className="flex flex-col gap-y-5">
          <p className="text-base">
            Somos o 1º e Maior Portal de Energia Solar do Brasil, com 7 anos de
            experiência e mais de 2.600 kWp instalados.
          </p>
          <p className="text-base">
            Como parte integrante do grupo Votorantim, somos uma empresa sólida
            e pautada pela ética.
          </p>
          <p className="text-base">
            Nascemos de uma inspiração australiana, em 2014, com a missão de
            democratizar a energia solar fotovoltaica. Ao longo dos 7 anos de
            empresa, nos estabelecemos como o pivô do mercado fotovoltaico
            auxiliando clientes e parceiros a conquistar o sonho de produzir a
            própria energia.
          </p>
          <p className="text-base">
            Atualmente atendemos clientes finais de todos os setores mantendo o
            padrão elevado de qualidade no equipamento fornecido e no serviço
            prestado.
          </p>
        </div>
        <div>
          <ul className="flex flex-col gap-y-7">
            <li className="flex flex-row items-center gap-x-2">
              <div className="bg-orange rounded-xl w-4 h-4"></div>
              <span>Mais de 7 anos de experiência no mercado.</span>
            </li>
            <li className="flex flex-row items-center gap-x-2">
              <div className="bg-orange rounded-xl w-4 h-4"></div>
              <span>Mais de 350 sistemas vendidos.</span>
            </li>
            <li className="flex flex-row items-center gap-x-2">
              <div className="bg-orange rounded-xl w-4 h-4"></div>
              <span>Mais de 7.7 milhões de kW/h gerados por ano.</span>
            </li>
            <li className="flex flex-row items-center gap-x-2">
              <div className="bg-orange rounded-xl w-4 h-4"></div>
              <span>Núcleo interno de engenharia.</span>
            </li>
            <li className="flex flex-row items-center gap-x-2">
              <div className="bg-orange rounded-xl w-4 h-4"></div>
              <span>Seguro da etapa de instalação.</span>
            </li>
            <li className="flex flex-row items-center gap-x-2">
              <div className="bg-orange rounded-xl w-4 h-4"></div>
              <span>Atendimento dedicado ao cliente.</span>
            </li>
            <li className="flex flex-row items-center gap-x-2">
              <div className="bg-orange rounded-xl w-4 h-4"></div>
              <span>Monitoramento remoto do gerador instalado.</span>
            </li>
            <li className="flex flex-row items-center gap-x-2">
              <div className="bg-orange rounded-xl w-4 h-4"></div>
              <span>Opções de financiamento e parcelamento*.</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  )
}
